import { useState } from "react";

import ChevronRightIcon from "@heroicons/react/24/solid/ChevronRightIcon";
import PencilSquareIcon from "@heroicons/react/24/solid/PencilSquareIcon";

import styles from "./AdminPanel.module.scss";
import AdminTool from "./adminTool/AdminTool";
import CopyLinkButton from "./copyLinkButton/CopyLinkButton";
import DiagnosticToggle from "./diagnosticToggle/DiagnosticToggle";
import PdfGenerator from "./pdfGenerator/PdfGenerator";
import PersonalizationManager from "./personalizationManager/PersonalizationManager";

export default function AdminPanel() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [openModal, setOpenModal] = useState<"personalization_manager" | null>(
    null
  );

  function onDismiss() {
    setOpenModal(null);
  }

  return (
    <aside className={styles.admin}>
      <button
        className={styles.topBar}
        onClick={() => setIsExpanded((e) => !e)}
      >
        <ChevronRightIcon
          className={styles.expandIcon}
          style={{ ...(isExpanded ? { transform: "rotate(90deg)" } : {}) }}
        />
        <p className={styles.title}>Canvas Admin 3000</p>
      </button>

      {isExpanded && (
        <div className={styles.expandedPanel}>
          <div className={styles.toolGrid}>
            <AdminTool
              Component={PersonalizationManager}
              Icon={PencilSquareIcon}
              description="Change or reset personalisations"
              isOpen={openModal === "personalization_manager"}
              onClick={() => setOpenModal("personalization_manager")}
              onDismiss={onDismiss}
              title="Personalisation manager"
            />

            <PdfGenerator />

            <DiagnosticToggle />

            <CopyLinkButton />
          </div>
        </div>
      )}
    </aside>
  );
}
